import FormattedMessage from 'I18n/components/FormattedMessage';
import { H5 } from 'UIComponents/elements/headings';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EnrollmentChecksTitle = ({
  status
}) => {
  if (status === 'PASSED') {
    return /*#__PURE__*/_jsx(H5, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.enrollmentChecks.passed.title"
      })
    });
  }
  return /*#__PURE__*/_jsxs(H5, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.enrollmentChecks.failed.title"
    }), /*#__PURE__*/_jsx(UIHelpIcon, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.enrollmentChecks.failed.tooltip"
      }),
      className: "m-left-2",
      tooltipPlacement: "top"
    })]
  });
};
export default EnrollmentChecksTitle;